'use es6';

export const getListingViewReferrer = state => state.details.get('referrer');